<div>
    <cmps-accordion [multi]="true">
        <ng-container *ngFor="let g of _caResult?.groups; let gl = last">
            <cmps-accordion-item
                class="cmps-cdk-border-width-0p cmps-cdk-border-solid cmps-cdk-border-color-grey-300"
                [class.cmps-cdk-mb-0dot25]="!gl"
                [class.cmps-cdk-mb-0]="gl"
                [isOpen]="!_collapsed"
                #item
            >
                <!-- TODO public accessor for cmps-accordion-item -> isOpen -->
                <cmps-accordion-header
                    class="cmps-ca-evaluation--header cmps-cdk-bg-color-blue-100 cmps-cdk-color-white cmps-cdk-mb-0 cmps-cdk-border-t-radius-4p cmps-cdk-px-1dot5"
                    [class.cmps-cdk-border-b-radius-4p]="!item._isOpen"
                >
                    <div
                        class="cmps-cdk-flex-grow-1 cmps-cdk-font-size-18p cmps-cdk-font-bold"
                    >
                        <div>{{ g?.label }}</div>
                    </div>
                    <div class="cmps-cdk-font-size-20p cmps-cdk-font-bold">
                        {{ g?.scorePercent ?? 0 | cmpsPercent: '1.0-0' }}
                    </div>
                </cmps-accordion-header>
                <cmps-accordion-content>
                    <div class="cmps-cdk-flex-100">
                        <div
                            class="cmps-cdk-px-1 cmps-cdk-py-0dot5"
                            [class.cmps-cdk-bg-color-blue-50]="
                                a?.evaluatedBool !== true
                            "
                            [class.cmps-cdk-bg-color-grey-600]="
                                a?.evaluatedBool === true
                            "
                            [class.cmps-cdk-border-b-radius-4p]="al"
                            *ngFor="let a of g?.areas; let al = last"
                        >
                            <div
                                class="cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-font-size-14p cmps-cdk-mb-0dot25 last-child:cmps-cdk-mb-auto cmps-cdk-h-36px"
                            >
                                <div class="cmps-cdk-mx-0dot5">
                                    <cmps-icon
                                        class="cmps-cdk-fill-green-100"
                                        svgIcon="check-circle"
                                        *ngIf="
                                            a?.doNotEvaluate !== true &&
                                            a?.evaluatedBool === true
                                        "
                                    ></cmps-icon>
                                    <cmps-icon
                                        class="cmps-cdk-fill-blue-100"
                                        svgIcon="alert-circle"
                                        *ngIf="
                                            a?.doNotEvaluate !== true &&
                                            a?.evaluatedBool !== true
                                        "
                                    ></cmps-icon>
                                    <cmps-icon
                                        class="cmps-cdk-fill-grey-400"
                                        svgIcon="circle-off-outline"
                                        *ngIf="a?.doNotEvaluate === true"
                                    ></cmps-icon>
                                </div>
                                <cmps-ts-tooltip-conditional
                                    selector=".cmps-cdk-line-clamp-2"
                                >
                                    <ng-container ngProjectAs="show">
                                        <div
                                            class="cmps-cdk-line-clamp-2 cmps-cdk-font-bold"
                                            [class.cmps-cdk-color-green-100]="
                                                a?.doNotEvaluate !== true &&
                                                a?.evaluatedBool === true
                                            "
                                            [cmpsTooltipTrigger]="a?.label"
                                        >
                                            <span>{{ a?.label }}</span>
                                        </div>
                                    </ng-container>
                                    <ng-container ngProjectAs="no-show">
                                        <div
                                            class="cmps-cdk-line-clamp-2 cmps-cdk-font-bold"
                                            [class.cmps-cdk-color-green-100]="
                                                a?.doNotEvaluate !== true &&
                                                a?.evaluatedBool === true
                                            "
                                        >
                                            <span>{{ a?.label }}</span>
                                        </div>
                                    </ng-container>
                                </cmps-ts-tooltip-conditional>
                                <div
                                    class="cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-ml-auto"
                                >
                                    <div
                                        class="cmps-cdk-mr-0dot5"
                                        [cmpsTooltipTrigger]="
                                            a?.evaluatedReasoning
                                        "
                                        *ngIf="
                                            showReasoning === true &&
                                            a?.doNotEvaluate !== true &&
                                            a?.evaluatedReasoning != null
                                        "
                                    >
                                        <cmps-icon
                                            class="cmps-cdk-fill-grey-300"
                                            svgIcon="information"
                                        ></cmps-icon>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </cmps-accordion-content>
            </cmps-accordion-item>
        </ng-container>
    </cmps-accordion>
</div>
